module.exports = __webpack_public_path__ + "img/图1-33绘制底稿的步骤.c2b5a761.png";